import { Cart } from 'shared-types'
import { GTMEvent, AddToCartDTO } from '~/lib'
import { adaptProduct } from './adaptProduct'

export const adaptAddToCart = ({
  cart,
  containerName,
}: {
  cart: Cart
  containerName?: string
}): AddToCartDTO => {
  const addedCartItems = cart?.lineItems

  const eventData: AddToCartDTO = {
    event: GTMEvent.ADD_TO_CART,
    ecommerce: null,
    container_name: null,
  }

  if (cart != null) {
    eventData.ecommerce = {
      currency: cart?.totalPrice?.currencyCode,
      items: addedCartItems.map((item) => {
        return adaptProduct({
          product: item,
          isUseTotalQuantityPriceFormat: true,
        })
      }),
    }
  }

  if (containerName) {
    eventData.container_name = containerName
  }

  return eventData
}
